// @flow
import React, { PureComponent, Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import { withHelmet } from 'infrastructure/seo/Helmet';
import { STATUS_DEFAULT, STATUS_LOADING, STATUS_FAILURE, STATUS_UNKNOWN } from 'constants/statusConstants';
import ClubTop from 'components/club/ClubTop';
import ClubAdress from 'components/club/ClubAdress';
import ClubPractices from 'components/club/ClubPractices';
import ClubNearby from 'containers/club/ClubNearbyContainer';
import ClubContact from 'components/club/ClubContact';
import type { Status } from 'types/Status';
import type { ClubType } from 'types/Club';
import { handleTagEvent } from 'utils/tagManagerUtils';
import Sidebar from 'components/sidebar/Sidebar';
import Loading from 'components/fragments/Loading';
import { ffrName } from 'utils/ffrNameUtils';

type OwnProps = {
  match: {
    params: {
      slug: string
    }
  }
};

export type StateProps = {
  club: ClubType,
  status: Status
};

export type DispatchProps = {
  fetchClub: (id: string) => void
};

type Props = StateProps & OwnProps & DispatchProps;

class Club extends PureComponent<Props> {
  componentDidMount() {
    this.props.fetchClub(this.props.match.params.slug);
  }

  componentDidUpdate(prevProps: Props) {
    const { slug } = this.props.match.params;
    if (prevProps.match.params.slug !== slug) {
      this.props.fetchClub(slug);
    }
  }

  renderContact() {
    const { name, website, email, phoneNumber, comite_directeur, pratiques_full } = this.props.club;

    if (!website && !phoneNumber && !email) {
      return null;
    }

    const contacts_pratiques = {};
    pratiques_full.forEach((pratique, i) => {
      if (pratique.contact && pratique.contact[0]) {
        if (contacts_pratiques['contact_' + pratique.contact[0].id ]) {
          contacts_pratiques['contact_' + pratique.contact[0].id ].fonction.push(pratique.name);
        } else {
          contacts_pratiques['contact_' + pratique.contact[0].id] = pratique.contact[0];
          contacts_pratiques['contact_' + pratique.contact[0].id].fonction = [];
          contacts_pratiques['contact_' + pratique.contact[0].id].fonction.push(pratique.name);
        }
      }
    });
    const contacts_pratiques_final = [];
    for (var key in contacts_pratiques) {
      if (contacts_pratiques.hasOwnProperty(key)) {
        contacts_pratiques_final.push(contacts_pratiques[key]);
      }
    }
    contacts_pratiques_final.sort((a, b) => {
      const x = a.prenom.toLowerCase();
      const y = b.prenom.toLowerCase();
      return x < y ? -1 : x > y ? 1 : 0;
    });
    if (website || email || phoneNumber || comite_directeur) {
      return (
        <React.Fragment>
          <h3 className="mb-3">Contact</h3>
          <ClubContact
            name={name}
            contacts={comite_directeur}
            contacts_pratiques={contacts_pratiques_final}
            email={email}
            website={website}
            phoneNumber={phoneNumber}
          />
        </React.Fragment>
      );
    }
    return null;
  }

  renderSocial = () => {
    const { facebook, twitter, name } = this.props.club;
    if (!facebook && !twitter) {
      return null;
    }
    return (
      <Fragment>
        <h3 className="mb-3">{"Suivre l'actualité du club"}</h3>
        <div className="block-share block-share--stack">
          {facebook && (
            <a
              href={facebook}
              className="btn btn--facebook btn--social"
              title={`Suivre l'actualité du club ${ffrName(name)} sur Facebook`}
              onClick={handleTagEvent('page club', "clic suivre l'actualite facebook", name)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="icon icon-facebook is-inline" />
              <span>sur Facebook</span>
            </a>
          )}
          {twitter && (
            <a
              href={twitter}
              className="btn btn--twitter btn--social"
              title={`Suivre l'actualité du club ${ffrName(name)} sur Twitter`}
              onClick={handleTagEvent('page club', "clic suivre l'actualite twitter", name)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="icon icon-twitter is-inline" />
              <span>sur Twitter</span>
            </a>
          )}
        </div>
      </Fragment>
    );
  };

  // TODO : check variable with status
  render() {
    const { name, teams, competitions, logo, adress, practices, pratiques_full, lat, long, sidebar } = this.props.club;
    const { status } = this.props;

    if (status === STATUS_DEFAULT || status === STATUS_LOADING) {
      return <Loading />;
    }

    if (status === STATUS_FAILURE || status === STATUS_UNKNOWN) {
      return <Redirect to="/404" />;
    }

    return (
      <React.Fragment>
        <div className="container">
          <div className="row">
            <div className="col col-md-8 col-lg-9 bg-overflow">
              <section>
                <div className="row">
                  <div className="col col-lg-8on9">
                    <ClubTop name={name} tags={practices} teams={teams} competitions={competitions} logo={logo} />
                    <ClubAdress lat={lat} long={long} name={name} adress={adress} />
                    {pratiques_full && <ClubPractices practices={pratiques_full} />}
                    {this.renderContact()}
                    {this.renderSocial()}
                  </div>
                </div>
              </section>
            </div>
            <Sidebar sidebarContent={sidebar} />
          </div>
        </div>
        <div className="container">
          <div className="row">
            <ClubNearby club={this.props.club} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withHelmet(Club)((Helmet, pageProps) => (
  <Helmet>
    <title>{pageProps.club.meta_title}</title>
    <meta name={'description'} content={pageProps.club.meta_description} />
  </Helmet>
));
